import { ConfigOption } from "@ngx-formly/core";
import { AddressComponent } from "./components/form/address/address.component";
import { ButtonTypeComponent } from "./components/form/button/button-type.component";
import { ChipsComponent } from "./components/form/chips/chips.component";
import { DropdownComponent } from "./components/form/dropdown/dropdown.component";
import { FileUploadComponent } from "./components/form/file-upload/file-upload.component";
import { LabelComponent } from "./components/form/label/label.component";
import { MultiSelectDropdownComponent } from "./components/form/multi-select-dropdown/multi-select-dropdown.component";
import { OtpGenerateComponent } from "./components/form/otp-generate/otp-generate.component";
import { PasswordComponent } from "./components/form/password/password.component";
import { RichTextEditorComponent } from "./components/form/rich-text-editor/rich-text-editor.component";
import { TextAreaComponent } from "./components/form/text-area/text-area.component";
import { LoginWrapperComponent } from "./components/login-screen/login-wrapper.component";
import { LoginWrapper1Component } from "./components/login-screen/login-wrapper1.component";
import { required } from "./messages";
import { FieldWrapperComponent } from "./wrappers/field-wrapper.component";
import { DatePickerComponent } from "./components/form/date-picker/date-picker.component";

export const DYNAMIC_FORM_CONFIG: ConfigOption = {
    wrappers: [
        { name: 'loginWrapper', component: LoginWrapperComponent },
        { name: 'fieldWrapper', component: FieldWrapperComponent },
        { name: 'group-wrapper', component: FieldWrapperComponent },
        { name :'loginWrapper1',component:LoginWrapper1Component}
    ],
    types: [
        { name: 'file-upload', component: FileUploadComponent },
        { name: 'text-area', component: TextAreaComponent },
        { name: 'dropdown', component: DropdownComponent },
        { name: 'multiSelect-Dropdown', component: MultiSelectDropdownComponent },
        { name: 'chips', component: ChipsComponent },
        { name: 'password', component: PasswordComponent },
        { name: 'button', component: ButtonTypeComponent },
        { name: 'custom-label', component: LabelComponent },
        { name: 'address-autocomplete', component: AddressComponent },
        { name: 'otp-generation', component: OtpGenerateComponent },
        { name: 'text-editor', component: RichTextEditorComponent },
        { name: 'date-picker', component: DatePickerComponent },
    ],
    validationMessages: [
        { name: 'required', message: required }
    ],
    validators: [
    ]
};